import React from "react"

interface ImageDataRendererProps {
  imageDataArray: string[]
}

const ImageDataRenderer: React.FC<ImageDataRendererProps> = ({
  imageDataArray,
}) => {
  // Convert ImageData to Blob URLs using useMemo for better performance
  // const imageUrls = useMemo(() => {
  //   return imageDataArray.map((imageData) => {
  //     const canvas = document.createElement("canvas")
  //     canvas.width = imageData.width
  //     canvas.height = imageData.height

  //     const ctx = canvas.getContext("2d")
  //     if (!ctx) {
  //       throw new Error("Failed to get canvas 2D context")
  //     }

  //     ctx.putImageData(imageData, 0, 0)

  //     // Convert the canvas content to a Blob and create an object URL for it
  //     return new Promise<string>((resolve) => {
  //       canvas.toBlob((blob) => {
  //         if (blob) {
  //           const url = URL.createObjectURL(blob)
  //           resolve(url)
  //         }
  //       }, "image/png")
  //     })
  //   })
  // }, [imageDataArray])

  // Render each image as an <img> element with Blob URLs
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
      {imageDataArray.map((promise, index) => (
        <React.Suspense
          fallback={<div key={index}>Wird geladen...</div>}
          key={index}
        >
          <AsyncImage url={promise} index={index} />
        </React.Suspense>
      ))}
    </div>
  )
}

// Async component to handle image rendering
const AsyncImage: React.FC<{ url: string; index: number }> = ({
  url,
  index,
}) => {
  return (
    <img
      src={url}
      alt={`Rendered ${index + 1}`}
      style={{
        width: "100%",
        maxWidth: 500,
        height: "auto",

        borderRadius: "4px",
      }}
    />
  )
}

export default ImageDataRenderer
